import React from 'react';
import { CustomFieldDefinition, useCustomFields } from '../hooks/useCustomFields';

interface Props {
  tabelle: string;
  authToken: string;
  values: Record<string, any>;
  onChange: (values: Record<string, any>) => void;
}

export const CustomFieldsForm: React.FC<Props> = ({ tabelle, authToken, values, onChange }) => {
  const { definitions, loading } = useCustomFields(tabelle, authToken);

  if (loading || definitions.length === 0) return null;

  const handleFieldChange = (key: string, value: any) => {
    onChange({ ...values, [key]: value });
  };

  return (
    <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px dashed var(--bone-3)' }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-2)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Zusätzliche Felder
      </div>
      {definitions.map((def) => (
        <CustomFieldInput
          key={def.feld_id}
          definition={def}
          value={values[def.schluessel]}
          onChange={(v) => handleFieldChange(def.schluessel, v)}
        />
      ))}
    </div>
  );
};

interface InputProps {
  definition: CustomFieldDefinition;
  value: any;
  onChange: (v: any) => void;
}

const CustomFieldInput: React.FC<InputProps> = ({ definition, value, onChange }) => {
  const { typ, label, pflicht, optionen, beschreibung } = definition;
  const baseStyle: React.CSSProperties = {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid var(--bone-3)',
    borderRadius: 0,
    fontSize: 14,
  };

  return (
    <div className="form-group" style={{ marginBottom: 12 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, marginBottom: 4 }}>
        {label}
        {pflicht && <span style={{ color: 'var(--red)' }}> *</span>}
        {beschreibung && (
          <span style={{ fontSize: 11, color: 'var(--ink-2)', marginLeft: 6 }} title={beschreibung}>(?)</span>
        )}
      </label>
      {typ === 'TEXT' && (
        <input type="text" value={value ?? ''} onChange={(e) => onChange(e.target.value)} required={pflicht} style={baseStyle} />
      )}
      {typ === 'TEXTAREA' && (
        <textarea value={value ?? ''} onChange={(e) => onChange(e.target.value)} required={pflicht} rows={3} style={baseStyle} />
      )}
      {typ === 'NUMBER' && (
        <input
          type="number" step="any"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value === '' ? null : parseFloat(e.target.value))}
          required={pflicht}
          style={baseStyle}
        />
      )}
      {typ === 'DATE' && (
        <input type="date" value={value ?? ''} onChange={(e) => onChange(e.target.value)} required={pflicht} style={baseStyle} />
      )}
      {typ === 'BOOLEAN' && (
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} style={{ transform: 'scale(1.3)' }} />
      )}
      {typ === 'SELECT' && (
        <select value={value ?? ''} onChange={(e) => onChange(e.target.value)} required={pflicht} style={baseStyle}>
          <option value="">-- Bitte wählen --</option>
          {(optionen || []).map((opt) => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      )}
    </div>
  );
};

export default CustomFieldsForm;
